import { ISetPiece, ISetPieces, SetPieceColor, SetPieceShape } from '../../models/SetPieces';
import { ActionType } from '../action-types';
import { Action } from '../actions';

const initialState: ISetPieces = {
	audience: {
		height: 0.92,
		pos: { x: 0, y: 0 },
		rotation: 0,
	},
	setPieces: [],
	nextSetPieceId: 1,
	selectedSetPieceId: 'audience',
};

const reducer = (state: ISetPieces = initialState, action: Action): ISetPieces => {
	switch (action.type) {
		case ActionType.ADD_SET_PIECE: {
			const newSetPiece: ISetPiece = {
				id: state.nextSetPieceId,
				name: 'Set Piece ' + state.nextSetPieceId,
				shape: SetPieceShape.Rectangle,
				color: SetPieceColor.Brown,
				pos: { x: 0, y: 100 },
				size: { x: 100, y: 100 },
				rotation: 0,
			};
			return {
				...state,
				setPieces: state.setPieces.concat(newSetPiece),
				nextSetPieceId: state.nextSetPieceId + 1,
				selectedSetPieceId: newSetPiece.id,
			};
		}
		case ActionType.SET_SET_PIECE_RECT: {
			return {
				...state,
				setPieces: state.setPieces.map(setPiece => {
					if (setPiece.id !== action.payload.id) return setPiece;
					
					let newRotation = action.payload.rotation;
					if (action.payload.size.y < 0) {
						newRotation += newRotation < 0 ? 180 : -180;
					}
					
					return { 
						...setPiece,
						pos: action.payload.pos,
						size: { x: Math.abs(action.payload.size.x), y: Math.abs(action.payload.size.y) },
						rotation: newRotation,
					};
				})
			};
		}
		case ActionType.SET_AUDIENCE_POS_ROTATION: {
			return {
				...state,
				audience: {
					...state.audience,
					pos: action.payload.pos,
					rotation: action.payload.rotation,
				},
			};
		}
		case ActionType.UPDATE_SET_PIECE_NAME: {
			return {
				...state,
				setPieces: state.setPieces.map((setPiece) => {
					if (setPiece.id !== action.payload.id) return setPiece;
					return {
						...setPiece,
						name: action.payload.name,
					};
				}),
			};
		}
		case ActionType.UPDATE_SET_PIECE_APPEARANCE: {
			return {
				...state,
				setPieces: state.setPieces.map((setPiece) => {
					if (setPiece.id !== action.payload.id) return setPiece;
					return {
						...setPiece,
						shape: action.payload.shape,
						color: action.payload.color,
					};
				}),
			};
		}
		case ActionType.DELETE_SET_PIECE: {
			return {
				...state,
				setPieces: state.setPieces.filter((setPiece) => setPiece.id !== action.payload.id),
			};
		}
		case ActionType.SET_SELECTED_SET_PIECE: {
			if (action.payload.id !== 'audience' && state.setPieces.find((setPiece) => setPiece.id === action.payload.id) === undefined) {
				console.error("Could not find SetPiece with id: " + action.payload.id);
				return state;
			}
			return {
				...state,
				selectedSetPieceId: action.payload.id,
			};
		}
		case ActionType.RESET_STATE: {
			return initialState;
		}
		default:
			return state;
	}
};

export default reducer;
